import { getItemsFromCollection } from "directus/src/operations";

export async function fetchDiscordForProject({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "item:integrations_discord.id",
        "item:integrations_discord.channel_id",

        "collection",
      ],
      filter: {
        projects: {
          _eq: id,
        },
        collection: {
          _eq: "integrations_discord",
        },
      },
    };
    const response = await getItemsFromCollection("projects__integrations", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchDriveForProject({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "item:integrations_drive.id",
        "item:integrations_drive.folder_id",

      ],
      filter: {
        projects: {
          _eq: id,
        },
        collection: {
          _eq: "integrations_drive",
        },
      },
    };
    const response = await getItemsFromCollection("projects__integrations", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchGithubForProject({ id }) {
  try {
    // Flat git_repositories rows for this project (no item/collection).
    const query = {
      fields: ["id", "repository_url", "suffix"],
      filter: { project: { _eq: id } },
    };
    const response = await getItemsFromCollection("git_repositories", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
